<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tv2yIJ/tc-custom/9781626864290.jpg?1738761514544" alt="This image is the cover for the book Uncle John's Weird Weird World Epic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle John's Weird Weird World Epic
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A collection of some of the wildest and weirdest trivia packed with incredible facts, obscure history, interesting origins, bizarre quotes, and more.</b></p><p> The second fully illustrated entry in Uncle John’s popular new Weird, Weird World series opens a portal to the bizarre. It’s page after page of unbelievable history, odd origins, tales of amazing luck, kooky conspiracy theories, epic fails, astounding facts, and some things that are so weird that they defy description. That’s where the pictures come in: Hundreds of eye-popping photographs and illustrations take the humor and the fun to a whole new dimension . . . to the EPIC zone! Read about . . . </p><p> •       How to Hypnotize a Chicken </p><p> •       The Origin of the Lie Detector </p><p> •       Weirdest Ways to Die at National Parks </p><p> •       Feral Cat Day and Other Strange-But-Real Holidays </p><p> •       Here Comes the Spammobile! </p><p> •       Keith Urban Legends </p><p> •       The Power of Poo </p><p> •       Winners of “Ugly Dog” Contests </p><p> •       Weird World Records </p><p> •       TV Shows That Were All a Dream </p><p> •       Kalshnikov Pat &amp; the Helicopter Jailbreakers </p><p> •       Odd-phrodisiacs </p><p> •       Japan’s Most Surreal Video Games </p><p> •       News Pundits Gone Wild </p><p> •       The Pacific Garbage Patch </p><p> •       Calamity Jane and the Old West’s Toughest Gals </p><p> •       What Your Nose Says About Your Love Life </p><p> •       Scams That Could Only Be Pulled Off by Identical Twins </p><p> •       Anarchy in the E.R. </p> And much, much more 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bathroom Readers' Institute
      </h2>
      
      <p class="authorDescription body article">The Bathroom Readers' Institute is a tight-knit group of loyal and skilled writers, researchers, and editors who have been working as a team for years. The BRI understands the habits of a very special market—Throne Sitters—and devotes itself to providing amazing facts and conversation pieces.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portable Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77262386